export const TOUR_POPOVER_WIDTH_PX = 300;